// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A445","label":"styles_label__1Obab"};